import { useEffect } from 'react'

import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'
import { useProcessContext } from 'modules/processes/pages/Process/ProcessRootPage'

import DueDateForm, { optionsForReferenceFields } from './DueDateForm'
import { defaultOffsetDirection } from './utils'

const Deadline = () => {
  const {
    associatedTaskItem: item,
    form,
    changeValue,
    setInitialFormValue,
    dueDateOpen,
    setDueDateOpen,
  } = useFormProvider()
  const { template, taskConfigurationSettings } = useProcessContext()
  const { reference_field_key } = form.values

  const onEnabledChange = () => setDueDateOpen((prev) => !prev)

  useEffect(() => {
    if (!taskConfigurationSettings) return

    setInitialFormValue({
      offset_amount: item?.offsetAmount || 0,
      offset_direction: item?.offsetDirection || defaultOffsetDirection()[0]?.value,
      reference_field_key:
        item?.referenceFieldKey ||
        optionsForReferenceFields(null, taskConfigurationSettings.referenceFieldKeys, template)[0]
          ?.value,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!reference_field_key) return null

  return (
    <>
      <DueDateForm
        readonly={false}
        form={form}
        openedForm={dueDateOpen}
        onEnabledChange={onEnabledChange}
        template={template}
        changeValue={changeValue}
      />
    </>
  )
}

export default Deadline
